/* eslint-disable react/prop-types */
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const TooltipIcon = ({ label, children, placement = 'top', ...iconProps }) => {
  return (
    <OverlayTrigger
      trigger={['focus', 'hover']}
      placement={placement}
      overlay={<Tooltip className={`text-danger`}>{label}</Tooltip>}
    >
      <span {...iconProps}>{children}</span>
    </OverlayTrigger>
  );
};

export default TooltipIcon;
